module.exports = __webpack_public_path__ + "img/2021-1.9be9fe19.jpg";